// ===== Packages =====

import {
    fetchSignInMethodsForEmail,
}                                           from 'firebase/auth';

// ===== Firebase =====

import fire                                 from '../fire';

// ===== Services =====

import {
    getAuthenticationTypeLabel,
    mapSignInMethodToAuthenticationType,
    formatProviderList,
}                                           from '.';

const { auth } = fire();

const getExistingEmailSignInGuidance = async ({
    email,
    fallback,
}: {
    email: string,
    fallback: string,
}): Promise<string> => {
    try {
        const methods = await fetchSignInMethodsForEmail(auth, email);
        const providerLabels = Array.from(
            new Set(methods.map((method) => {
                const authenticationType = mapSignInMethodToAuthenticationType(method);
                if (!authenticationType) return method;
                return getAuthenticationTypeLabel(authenticationType);
            })),
        );
        if (providerLabels.length === 0) return fallback;
        const providerList = formatProviderList(providerLabels);
        return `This email is already linked to ${providerList}. Try signing in with ${providerList} first.`;
    } catch {
        return fallback;
    }
};

export default getExistingEmailSignInGuidance;
